import React, { useState } from "react";
import cn from "classnames";
import { CUSTOM_MESSAGES, LABEL } from "../../veriables";
import styles from "./indexCopy.module.scss";
import { connect } from "react-redux";
import Modal from "@components/common/Modal";
import { updateEmployeeCashOut } from "@reducers/cashOut";
import { bindActionCreators } from "redux";
import { setNotification } from "@reducers/notification";
import { getObjectValue } from "@utility/utills";
import { APP_CONFIG } from "@constants";
import { logout } from "@reducers/oauth";
import Loader from "@components/common/Loader/newLoaderModal";
import { ReactComponent as Cross } from "@assets/images/cross.svg";
import FullWidthModal from "../common/Modal/FullWidthModal";
import ModalHeader from "../common/ModalHeader";
import { TouchableButton } from "@components/common/Touchable";

const ServerCashOutReport = (props) => {
  const { serverAppTheme } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const isLandScape = !props.orderingPortraitOrientation;
  const response = props.location?.state?.response;

  const handleAmountBlur = (string) => {
    const element = document.querySelector(`#${string}`);
    element.blur();
  };

  const returnName = () => {
    if (Number(response?.balance) > 0) {
      return LABEL().AMOUNT_DUE;
    }
    if (Number(response?.balance) < 0) {
      return LABEL().AMOUNT_OWED;
    }
    return LABEL().NOTHING_DUE_OWED;
  };

  const returnCashierName = () => {
    if (Number(response?.balance) > 0) {
      return LABEL().AMOUNT_OVER;
    }
    if (Number(response?.balance) < 0) {
      return LABEL().AMOUNT_SHORT;
    }
    return LABEL().NOTHING_OVER_SHORT;
  };
  

  const handleLogout = () => {
    setLoader(true);
    const dataTosend = {
      latitude: "92",
      longitude: "92",
      deviceId: props.deviceInfo.deviceId,
      employeeId: getObjectValue(() => props.userInfo.externalId, null),
      employeeCard: getObjectValue(() => props.userInfo.employeeCard, null),
    };
    props.logout(dataTosend);
    props.navigate(`${APP_CONFIG.BASE_URL}/checkIn?step=1`, { replace: true });
  };

  const handleCashOut = () => {
    const dataToSend = {
      storeId: props.userInfo.storeId,
      employeeId: props.userInfo.id,
      deviceId: props.deviceInfo.deviceId,
      amount: response?.balance || 0,
    };
    props
      .updateEmployeeCashOut(dataToSend)
      .then(() => {
        handleLogout();
      })
      .catch((err) => {
        setLoader(false);
        props.setNotification({
          type: "danger",
          message: err.message,
        });
      });
  };

  const amountTypes = [
    {
      key: "bankAmount",
      name: LABEL().BANK_AMOUNT,
      value: response?.bank,
    },
    {
      key: "paidInAmount",
      name: LABEL().PAID_IN_AMOUNT,
      value: response?.paidIn,
    },
    {
      key: "paidOutAmount",
      name: LABEL().PAID_OUT_AMOUNT,
      value: response?.paidOut,
    },
    {
      key: "cashDropAmount",
      name: LABEL().CASH_DROP_AMOUNT,
      value: response?.cashDrop,
    },
    {
      key: "cashPaymentAmount",
      name: LABEL().CASH_PAYMENT_AMOUNT,
      value: response?.cashPayment,
    },
    {
      key: "creditCardPaymentAmount",
      name: LABEL().CREDIT_CARD_PAYMENT_AMOUNT,
      value: response?.creditCardPayment,
    },
    {
      key: "creditCardTipAmount",
      name: LABEL().CREDIT_CARD_TIP_AMOUNT,
      value: response?.creditCardTip,
    },
    {
      key: "pendingCashoutAmount",
      name: LABEL().PENDING_CASHOUT_AMOUNT,
      value: response?.pendingCashOut,
    },
    {
      key: "overShortAmount",
      name: LABEL().OVER_SHORT_AMOUNT,
      value: response?.overShort,
    },
    {
      key: "tipOut",
      name: LABEL().TIP_OUT,
      value: response?.tipOut,
    },
    {
      key: "cashOutDepositAmount",
      name: LABEL().CASH_OUT_DEPOSIT_AMOUNT,
      value: response?.cashOutDeposit,
    },
  ];

  const handleClose = () => {
    props.navigate(`${APP_CONFIG.BASE_URL}/serverApp/checks`, {
      replace: true,
    });
  };

  return (
    <>
      {props.loading && <Loader />}
      <div
        style={{
          color: "#000",
        }}
      >
        <ModalHeader
          tileHeader={
            response?.jobType !== 4
              ? LABEL().SERVER_CASHOUT_REPORT
              : LABEL().CASHIER_CASHOUT_REPORT
          }
        />
      </div>
      <div className={cn(isLandScape ? "row mx-0 p-12" : '')}>
        {props.loading && <Loader />}
        <div
          className={cn(
            isLandScape ? "col-12 px-12 pb-12 pt-0 d-flex justify-content-between" : 'p-3 mr-20 ml-20 mt-20 mb-20',
            styles.boxBorder,
          )}
        >
          {/* Left section */}
          <div className={cn("h-100", isLandScape? 'col-6 pr-4 pl-0' : 'col-12 px-0')}>
            {amountTypes &&
              amountTypes.slice(0, 6).map((item) => {
                return (
                  <div className={cn("col-12 py-12 d-flex px-0")}>
                    <div className={cn("col-8 px-0", styles.txtStyle)}>
                      {item.name}
                    </div>
                    <div
                      className={cn(
                        "col-4 fw-600 px-0 text-right",
                        isLandScape? '': 'fs-18',
                        styles.txtStyle,
                      )}
                    >
                      {LABEL().CURRENCY_SYMBOL}
                      {item?.value?.toFixed(2)}
                    </div>
                  </div>
                );
              })}
          </div>
          {/* Right section */}
          <div className={cn("h-100", isLandScape? ' col-6 pl-3 pr-0' : 'col-12 px-0')}>
            {amountTypes &&
              amountTypes.slice(6, 11).map((item, index) => {
                return (
                  <div className={cn("col-12 py-12 d-flex px-0")}>
                    <div className={cn("col-8 px-0", styles.txtStyle)}>
                      {item.name}
                    </div>
                    <div
                      className={cn(
                        "col-4 fw-600 px-0 text-right",
                        isLandScape? '': 'fs-18',
                        styles.txtStyle,
                      )}
                    >
                      {LABEL().CURRENCY_SYMBOL}
                      {item?.value?.toFixed(2)}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        {isLandScape && <div className={cn("col-12 px-0 mx-0", styles.mtBotm)}>
          <div
            className={cn(
              "col-7 mx-auto fs_24 fw-600 color-black",
            )}
          >
            <div className={cn("col-12 d-flex justify-content-center align-items-center color-black")}>
              {response?.jobType !== 4 ? returnName() : returnCashierName()}
            </div>
            <div className="col-12 d-flex justify-content-center align-items-center color-black">
                <div>
                  {LABEL().CURRENCY_SYMBOL}
                  {Math.abs(Number(response?.balance ?? 0)).toFixed(2)}
                </div>
            </div>
          </div>
        </div>}
        {/* Buttons */}
        <div className="col-12 mt-20">
          <div
            className={cn(
              "col-12 px-0",
              isLandScape? 'd-flex' : '',
              styles.bottomBtns,
            )}
          >
            {!isLandScape && <div
                className={cn(
                  "mx-auto fs_24 mb-4 fw-600 color-black",
                )}
              >
                <div className={cn("col-12 d-flex justify-content-center align-items-center color-black")}>
                  {response?.jobType !== 4 ? returnName() : returnCashierName()} : {LABEL().CURRENCY_SYMBOL}
                  {Math.abs(Number(response?.balance ?? 0)).toFixed(2)}
                </div>
              </div>}
            <div className={cn('col-12 row mx-0 justify-content-center align-items-center', isLandScape ? 'px-0': "pr-20 pl-20")}>
            <div className={cn(isLandScape? "col-5 text-center pl-0 pr-2" : 'col-6 pr-1 pl-0')}>
              <TouchableButton
                className={cn(
                  isLandScape ? 'btn44' : 'btn68',
                  "btn-ripple w-100 fs_28 od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color fw-600",
                )}
                style={{
                  borderRadius: "4px",
                  border: "1px solid #2541A4",
                  backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                  color: serverAppTheme?.primary_text,
                }}
                type="button"
                onClick={(e) => {
                  handleClose();
                  e.preventDefault();
                }}
                rippleEffect={true}
              >
                {LABEL().CO_CANCEL}
              </TouchableButton>
            </div>
            <div className={cn(isLandScape? "col-5 text-center p-0" : 'col-6 pl-1 pr-0')}>
              <TouchableButton
                className={cn(
                  isLandScape ? 'btn44' : 'btn68',
                  "btn-ripple shadow-none border-0 w-100 fs_28 od-primary-btn-bg-color od-primary-btn-font-color fw-600",
                )}
                style={{
                  borderRadius: "4px",
                  background: serverAppTheme?.secondaryBtn,
                  color: serverAppTheme?.btn_font_color,
                }}
                type="button"
                onClick={(e) => {
                  response?.jobType !== 4 ? setIsOpen(true) : handleLogout();
                  e.preventDefault();
                }}
                rippleEffect={true}
              >
                {response?.jobType !== 4 ? LABEL().CASH_OUT : LABEL().DONE}
              </TouchableButton>
            </div>
            </div>
          </div>
        </div>
      </div>
      {isOpen && (
        <Modal
          isOpen={isOpen}
          isModalCenter
          style={{
            width: "460px",
            margin: "auto",
            backgroundColor: serverAppTheme?.popUp_bg,
            borderRadius: "16px",
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
          }}
          noBackground
        >
          <div
            className="p-4 justify-content-center align-items-center text-center"
            style={{ color: serverAppTheme?.primary_text }}
          >
            <div className="col-12 fs_16 fw-500 text-center">
              {CUSTOM_MESSAGES().CONFIRM_CASHOUT}
            </div>
            <div className="col-12 mt-4 mx-0 px-0 d-flex justify-content-center">
              <TouchableButton
                type="submit"
                className={cn("col-6 btn44 mr-2")}
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
                style={{
                  border: serverAppTheme?.cancleBtn_Border,
                  background: serverAppTheme?.OFF_Premise_Btn,
                  color: serverAppTheme?.cancleBtn_font,
                }}
                rippleEffect={true}
              >
                <div className="fs_24">{LABEL().NO}</div>
              </TouchableButton>
              <TouchableButton
                type="submit"
                className={cn("col-6 btn44 ml-2")}
                onClick={() => {
                  handleCashOut();
                  setLoader(true);
                  setIsOpen(!isOpen);
                }}
                style={{
                  backgroundColor: serverAppTheme?.secondaryBtn,
                  color: serverAppTheme?.btn_font_color,
                }}
                rippleEffect={true}
              >
                <div className="fs_24">{LABEL().YES}</div>
              </TouchableButton>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
const mapStateToProps = ({ oauth, theme, orders }) => ({
  loading: oauth.loading,
  auth: oauth.authInfo,
  deviceInfo: oauth.deviceInformation,
  userInfo: oauth.loggedInUserData,
  loggedInUser: oauth.loggedInUser,
  serverAppTheme: theme.serverAppTheme,
  orderingPortraitOrientation: orders.orderingPortraitOrientation
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateEmployeeCashOut,
      setNotification,
      logout,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ServerCashOutReport);
